import { useState } from "react";
import { Card, Button, Form, ListGroup } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import localization from "services/localization";

export default function ArrayInput({
  label,
  values = [],
  onChange,
  placeholder,
  isRequired,
  errors,
  Icon,
  addButtonText = "Add",
}) {
  const [newValue, setNewValue] = useState("");
  const [isAdding, setIsAdding] = useState(false);

  const addValue = () => {
    if (newValue.trim()) {
      onChange([...values, newValue.trim()]);
      setNewValue("");
      setIsAdding(false);
    }
  };

  const removeValue = (index) => {
    onChange(values.filter((_, i) => i !== index));
  };

  const cancelAdd = () => {
    setNewValue("");
    setIsAdding(false);
  };

  return (
    <Card className="mb-4 shadow-sm instruction-card">
      <div className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
        <div className="d-flex align-items-center gap-2">
          {Icon && <Icon size={20} className="text-primary" />}
          <h5 className="mb-0 font-semibold">
            {label} {isRequired && <span style={{ color: "red" }}>*</span>} (
            {values.length})
          </h5>
        </div>
        {!isAdding && (
          <Button size="sm" variant="primary" onClick={() => setIsAdding(true)}>
            {addButtonText}
          </Button>
        )}
      </div>

      <Card.Body>
        {isAdding && (
          <Form className="mb-3">
            <Form.Control
              type="text"
              placeholder={placeholder || ""}
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
            />
            <div className="mt-2 d-flex gap-2">
              <Button
                variant="success"
                size="sm"
                onClick={addValue}
                disabled={!newValue.trim()}
              >
                {addButtonText}
              </Button>
              <Button variant="outline-secondary" size="sm" onClick={cancelAdd}>
                {localization.cancel || "Cancel"}
              </Button>
            </div>
          </Form>
        )}

        {values.length === 0 ? (
          <div className="text-muted text-center py-3">
            {localization.no_items_added_yet || "No items added yet"}
          </div>
        ) : (
          <ListGroup>
            {values.map((v, i) => (
              <ListGroup.Item
                key={i}
                className="list-item d-flex justify-content-between align-items-center"
              >
                <div>
                  {i + 1}. {v}
                </div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeValue(i)}
                >
                  <FaTrashAlt size={14} />
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}

        {errors?.pec && (
          <div className="text-danger small mt-1">{errors.pec}</div>
        )}
      </Card.Body>
    </Card>
  );
}
